function s(){const{$el:s,classNames:e}=this;s.removeClass(e.join(" ")),this.emitContainerClasses()}export{s as default};
//# sourceMappingURL=removeClasses.js.map
